module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp3_0.ed49be55.png";